import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import apiRequest from "../../../functions/api";
import {
  Paper,
  TextField,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import BetragInput from "../../shared/components/BetragInput";
import Grid from "@mui/material/Grid";
import { useMessage } from "../../../context/message-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { responsiveFontSizes, useTheme } from "@mui/material/styles";
import openFile from "../../shared/functions/download";
import CloseIcon from "@mui/icons-material/Close";
import NewExpense from "../NewExpense";
import ExpenseMobileTable from "../ExpenseMobileTable";
import ExpenseTable from "../ExpenseTable";
import { getFile } from "../getFile";
import EditAusgabe from "./EditAusgabe";
import ExpenseCard from "./ExpenseCard";
import AddIcon from "@mui/icons-material/Add";
function BelegEingabe(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { accessToken, client, element, program, ChangeFiles, lock, files, mehrereBelegeErlauben, formular } = props;
  const { showErrorMessage } = useMessage();

  const [editExpenseModal, setEditExpenseModal] = useState(false);
  const [isBelegLoading, setIsBelegLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [editedIndex, setEditedIndex] = useState(0);
  const [settings, setSettings] = useState({});
  const [artikelOptionen, setArtikelOptionen] = useState([]);
  const [kostenstellenOptionen, setKostenstellenOptionen] = useState([]);
  const [editModus, setEditModus] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedArtikel, setSelectedArtikel] = useState([]);
  const [belege, setBelege] = useState([]);
  const [selectedBeleg, setSelectedBeleg] = useState([]);
  const [staaten, setStaaten] = useState([]);
  const [neueAusgabeWerte, setNeueAusgabeWerte] = useState({
    file: "",
    WERTE: {
      BETREFF: "",
      DATUM: "",
      GESAMT: "",
      waehrung: "EURO",
      KURS: "1",
      AUSZAHLUNG: "0",
      ERGEBNIS: "0",
    },
  });
  const controller = useRef(new AbortController());
  const [addExpenseModal, setAddExpenseModal] = useState("");
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSettings(element.inhalt);
    if (program === "FORGEN") {
      return;
    } // init()
    let tage = [];

    setBelege(element.felderAntworten ? element.felderAntworten : []);
  }, [element]);

  useEffect(() => {
    if (program === "PMURA3") {
      return;
    }
    updateElement();
  }, [belege]);

  const updateElement = () => {
    let summe = 0;
    let sammelFelder = [];
    belege.forEach((beleg) => {
      summe += parseFloat(beleg?.["AUSZAHLUNG"]);
      sammelFelder.push(beleg);
    });
    element.antwort = summe;
    element.felderAntworten = sammelFelder;
    props.onChange(element.key, element, undefined);
  };
  const addBeleg = (beleg) => {
    if (editedIndex === "NEU") {
      let zwis = belege;
      zwis.push(beleg);
      setBelege([...zwis]);
    } else {
      let zwis = belege;
      zwis[editedIndex] = beleg;
      setBelege([...zwis]);
    }
    setEditExpenseModal(false);
    updateElement();
  };
  const init = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_INIT",
      formular: formular,
    };
    apiRequest("POST", "daten", payload, headers, initCB, setRedirect);
  };
  const initCB = (response) => {
    // setAufwendungen(response.data.aufwendungen)
    setKostenstellenOptionen(response.data.kostenstellen);
    setStaaten(response.data.staaten);
    setArtikelOptionen(response.data.artikelOptionen);
    setCurrencies(response.data.waehrungen);
  };
  const setRedirect = (path) => {
    navigate(path);
  };

  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
      signal: controller.current.signal,
    });
  };

  function readFile(event, tmpkey, kz) {
    ChangeFiles(event.target.files[0]);
    setIsBelegLoading(true);
    const payload = {
      program: program,
      statement: "OCR",
      mandant: client,
    };
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    formData.append("file", event.target.files[0]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiDataRequest(formData, headers).then(readFileCB).catch(console.log);

    return () => {
      controller.current.abort();
    };
  }
  const readFileCB = (response) => {
    setIsBelegLoading(false);
    let betreffAlt = neueAusgabeWerte.WERTE.BETREFF;
    let betreffArtikel_KEY = neueAusgabeWerte.WERTE.ARTIKEL_KEY;
    let neuerBeleg = {};
    neuerBeleg.file = files[files.length - 1];
    if (response.status === 200) {
      neuerBeleg["WERTE"] = response.data.WERTE;
      if (!neuerBeleg["WERTE"].ARTIKEL_KEY) {
        neuerBeleg["WERTE"].ARTIKEL_KEY = betreffArtikel_KEY;
      }
      if (!neuerBeleg["WERTE"].BETREFF) {
        neuerBeleg["WERTE"].BETREFF = betreffAlt;
      }
      neuerBeleg["WERTE"].waehrung = "EURO";
      neuerBeleg["WERTE"].KURS = "1";
      neuerBeleg["WERTE"].ERGEBNIS = parseFloat(response.data.WERTE.GESAMT).toFixed(2);
      neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat(response.data.WERTE.GESAMT).toFixed(2);
      neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
      neuerBeleg["WERTE"].artikel = response.data.WERTE.artikel;
      neuerBeleg["WERTE"].fileNumber = files.length;
      response.data.WERTE?.ARTIKEL?.forEach((element, index) => {
        if (!element.ARTIKEL_KEY) {
          neuerBeleg["WERTE"].ARTIKEL[index].ARTIKEL_KEY = betreffArtikel_KEY;
        }
      });
      if (!response.data?.WERTE?.ARTIKEL) {
        neuerBeleg["WERTE"].GESAMT = "0";
        showErrorMessage("Beleg konnte nicht vollständig ausgelesen werden. Bitte tragen Sie die fehlenden Daten manuell ein!");
        setFehlerFound(true);
        addArtikel(0);
      } else if (response.data.auslesenFehler === "1") {
        showErrorMessage("Beleg konnte nicht vollständig ausgelesen werden. Bitte tragen Sie die fehlenden Daten manuell ein!");
        setArtikelDialog(true);
        setFehlerFound(true);
        const index = response.data.WERTE?.ARTIKEL?.length - 1;
        setSelectedArtikel({ ...response.data.WERTE?.ARTIKEL[index], index });
        setLetzteAenderung("BETRAG");
        setEditModus(true);
      }
    } else {
      neuerBeleg["WERTE"] = {};
      neuerBeleg["WERTE"].ARTIKEL_KEY = betreffArtikel_KEY;
      neuerBeleg["WERTE"].ARTIKEL_KEY = betreffAlt;
      neuerBeleg["WERTE"].DATUM = "0000-00-00";
      neuerBeleg["WERTE"].waehrung = "EURO";
      neuerBeleg["WERTE"].KURS = "1";
      neuerBeleg["WERTE"].ERGEBNIS = parseFloat("0").toFixed(2);
      neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat("0").toFixed(2);
      neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
      neuerBeleg["WERTE"].fileNumber = files.length;
      showErrorMessage("Beleg konnte nicht ausgelesen werden. Bitte tragen Sie die Daten manuell ein!");
    }
    setNeueAusgabeWerte(neuerBeleg);
  };
  const cancelLoading = () => {
    let neuerBeleg = {};
    neuerBeleg.file = files[files.length - 1];

    neuerBeleg["WERTE"] = {};
    neuerBeleg["WERTE"].DATUM = "0000-00-00";
    neuerBeleg["WERTE"].waehrung = "EURO";
    neuerBeleg["WERTE"].KURS = "1";
    neuerBeleg["WERTE"].ERGEBNIS = parseFloat("0").toFixed(2);
    neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat("0").toFixed(2);
    neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
    neuerBeleg["WERTE"].fileNumber = files.length;
    showErrorMessage("Belegerkennung wurde abgebrochen. Bitte Werte manuell ausfüllen!");
    setIsBelegLoading(false);
    controller.current.abort();
    setNeueAusgabeWerte(neuerBeleg);
  };

  const addArtikel = (count) => {
    var index = count;
    if (count === 0) {
      setSelectedArtikel({
        Artikelbezeichnung: "",
        NETTO: "0",
        STEUER: "0",
        STEUERSATZ: "0",
        BETRAG: "0",
        index: index + 1,
      });
    } else {
      const letzterArtikel = neueAusgabeWerte?.WERTE?.ARTIKEL[count - 1];
      setSelectedArtikel({
        Artikelbezeichnung: letzterArtikel?.Artikelbezeichnung,
        ARTIKEL_KEY: letzterArtikel?.ARTIKEL_KEY,
        NETTO: "0",
        STEUER: "0",
        STEUERSATZ: "0",
        BETRAG: "0",
        index: index + 1,
      });
    }
    setArtikelDialog(true);
    setSelectedTab(index);
    setEditModus(true);
  };

  const WertChange = (was, wert) => {
    const zwis = neueAusgabeWerte;
    let artikel = zwis.WERTE["ARTIKEL"] ?? [];
    switch (was) {
      case "ARTIKEL_REMOVE":
        zwis.WERTE.ARTIKEL.splice(wert, 1);
        break;
      case "ARTIKEL":
        const index = wert.index;
        if (index > artikel.length) {
          artikel.push(wert);
          zwis.WERTE[was] = artikel;
        } else {
          artikel[index] = wert;
          zwis.WERTE[was] = artikel;
        }
        break;
      case "ARTIKEL_KEY":
        // Finde das passende Artikel-Option-Objekt in der artikelOptionen-Array
        const artikelOption = artikelOptionen.find((e) => e.key === wert);
        if (artikelOption) {
          zwis.WERTE["BETREFF"] = artikelOption.bez;
        }
        zwis.WERTE[was] = wert;

        for (let i = 0; i < artikel.length; i++) {
          //Setze Artikelobjekt wenn das Artikel-Objekt an der aktuellen Position leer ist
          if (artikel[i].ARTIKEL_KEY === "" || !artikel[i].ARTIKEL_KEY) {
            artikel[i].ARTIKEL_KEY = wert;
          }
        }
        zwis.WERTE["ARTIKEL"] = artikel;
        break;
      case "waehrung":
      case "DATUM":
        zwis.WERTE[was] = wert;
        if (was === "waehrung" && wert === "EURO") {
          zwis.WERTE["KURS"] = "1";
        } else {
          getKurs(zwis["WERTE"]["waehrung"], zwis["WERTE"]["DATUM"]);
        }
        break;
      default:
        zwis.WERTE[was] = wert;
        break;
    }
    zwis.WERTE["ERGEBNIS"] = parseFloat(parseFloat(neueAusgabeWerte.WERTE?.["GESAMT"]) / parseFloat(neueAusgabeWerte.WERTE?.["KURS"])).toFixed(2);
    zwis.WERTE["AUSZAHLUNG"] = neueAusgabeWerte.WERTE?.["KREDITKARTE"] === true ? "0,00" : zwis["WERTE"]["ERGEBNIS"];
    setNeueAusgabeWerte({ ...zwis });
  };
  const removeBeleg = (index) => {
    setBelege(belege.filter((e, count) => count !== index));
    updateElement();
  };
  const getKurs = (waehrung, datum) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_GET_KURS",
      waehrung: waehrung,
      datum: datum,
    };
    apiRequest("POST", "daten", payload, headers, getKursCb, setRedirect);
  };
  const getKursCb = (response) => {
    WertChange("KURS", response.data.kurs);
  };

  const onExpenseSelect = (beleg, index) => {
    setEditedIndex(index);
    setSelectedBeleg(beleg);
    setEditExpenseModal(true);
  };
  const removeExpense = (index) => {
    setBelege(belege.filter((e, count) => count !== index));
    updateElement();
  };

  const openBeleg = (beleg) => {
    const key = beleg.fileKey ? beleg.fileKey : beleg.fileNumber;
    const art = beleg.fileKey ? "key" : "hvdt";
    const fileName = beleg.fileName;
    const fileNameWithoutExtension = fileName.split(".")[0];
    getFile(client, accessToken, key, fileNameWithoutExtension, art)
      .then((file) => {
        openFile(file.name, file.content, file.type);
      })
      .catch((err) => {
        showErrorMessage(err);
      })
      .finally(() => {});
  };
  const openDatei = (beleg, art) => {
    const payload = {
      mandant: client,
      program: program,
      art: art,
      fileKey: beleg.fileKey,
      statement: "BELEGERKENNUNG_OPEN_BELEG",
    };
    const data = new FormData();

    data.append("file", beleg.file);

    data.append("payload", JSON.stringify(payload));
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_OPEN_BELEG",
    };
    axios
      .post(API_BASE_URL + "upload", data, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = beleg.file.name;

        var mimeType = response.headers["content-type"] || "application/pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile, mimeType);
      })
      .catch(function (error) {
        //   setSpin(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  const resetBelegEdit = () => {
    setEditExpenseModal(false);
    // setEditedIndex("");
    // setSelectedBeleg([]);
  };
  return (
    <>
      <Grid item xs={12} alignItems={"center"} md={12}>
        <Paper sx={{ p: 1 }}>
          <Box sx={{ display: { xs: "none", sm: "none" } }}>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h4" align="left">
                  Ausgaben
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  disabled={lock || (!mehrereBelegeErlauben && belege.length === 3)}
                  variant="outlined"
                  onClick={() => {
                    (setEditExpenseModal(true), setEditedIndex("NEU"));
                  }}
                >
                  Hinzufügen
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
            {belege
              ?.filter((e) => e.gesamtBrutto != "")
              .map((item, index) => {
                return (
                  <ExpenseCard expense={item} index={index} onExpenseSelect={onExpenseSelect} removeBeleg={removeBeleg} openBeleg={openBeleg} lock={lock} />
                );
              })}
          </Box>
          <Box sx={{ display: { xs: "block", sm: "block" } }}>
            <Grid container>
              <Grid item xs={6} sx={{ display: "flex" }}>
                <Typography variant="h4" align="left">
                  Ausgaben
                </Typography>
                <Button
                  disabled={lock || (!mehrereBelegeErlauben && belege.length === 3)}
                  variant="outlined"
                  onClick={() => {
                    (setEditExpenseModal(true), setEditedIndex("NEU"));
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
            <Grid container>
              {belege
                ?.filter((e) => e.gesamtBrutto != "")
                .map((item, index) => {
                  return (
                    <Grid item xs={12} sm={6} md={4} xl={2}>
                      <ExpenseCard expense={item} index={index} onExpenseSelect={onExpenseSelect} openBeleg={openBeleg} removeBeleg={removeBeleg} lock={lock} />
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
        </Paper>
      </Grid>
      <EditAusgabe
        artikelOptionen={artikelOptionen}
        kostenstellenOptionen={kostenstellenOptionen}
        accessToken={accessToken}
        open={editExpenseModal}
        lock={lock}
        client={client}
        readFile={readFile}
        program={program}
        settings={settings}
        onOpenChange={resetBelegEdit}
        openBeleg={openBeleg}
        selectedBeleg={belege[editedIndex]}
        addBeleg={addBeleg}
        currencies={currencies}
      />
    </>
  );
}

export default BelegEingabe;
